<template>
    <div class="withdrawal-help-modal-sec">
        <div class="withdrawal-help-modal modal fade" id="payment-policy" tabindex="-1"
            aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="pop-upWithdrawalHelp-content_title term-header-main">
                        <p class="para-three">{{$t('the-terms-of-payment-and-withdrawal-policy','The terms of payment and withdrawal policy')}}</p>
                        <button class="btn-close1" data-bs-dismiss="modal">
                            <img src="@/assets/images/cross-icon.webp" alt="cross-icon">
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="pop-upWithdrawalHelp-content">
                            <div class="terms-withdrow__container-p1">
                                Limits The maximum deposit limit on your account will vary depending on how long you have been a customer with us and whether you have successfully passed our security checks. Please contact the 
                               <a class="terms-support" href="mailto:support@{{ $siteSettings.data.url }}">support@{{ $siteSettings.data.url }}</a> for further information.
                                

                            </div>
                            <div class="terms-withdrow__container-p2">
                                Security Please note you may be asked to supply proof of identity and address before making a withdrawal from your account. Credit and Debit card payments undergo a 3D Secure process. To find out more, please click here.
                            </div>
                            <div class="terms-withdrow__container-p3">
                                Withdrawals Withdrawals will be directed to the same source. If your query is not covered by the information contained here, please email 
                                <a class="terms-support" href="mailto:support@{{ $siteSettings.data.url }}">support@{{ $siteSettings.data.url }}</a> where staff will be on hand to answer your query.
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer m-0">
                        <div class="deposit-back-btn m-0 pb-3">
                            <a href="javascript:void(0)" data-bs-dismiss="modal" class="terms-withdrow__container-buttonback m-0">Back</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PaymentPolicy'
}
</script>

<style>

.pop-upWithdrawalHelp-content {
    text-transform: initial;
}

</style>